export default __webpack_public_path__ + "static/media/G0400.34I-27244_-17343_0.1666263420000.18aaf70f.jpg";